import {asMapOrThrow, asStringOrThrow} from '@cohort/shared/typeUtils';

export function parseJwtToken(data: unknown): string {
  const anyMap = asMapOrThrow(data);
  return asStringOrThrow(anyMap.token);
}
